module.exports = __webpack_public_path__ + "static/media/31_tn.27eeed13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/31_tn.jpg
// module id = 244
// module chunks = 0